/* eslint-disable-next-line no-restricted-imports */
import * as t from 'io-ts';

export enum NotificationType {
  /** @knipignore Knip has trouble detecting enum members not referred to explicitly. */
  alert = 'alert',
  /** @knipignore */
  card = 'card',
  /** @knipignore */
  modal = 'modal',
  /** @knipignore */
  upsell = 'upsell',
}

const tManagerNotification = t.type({
  id: t.union([t.number, t.string]),
  action_enabled: t.boolean,
  action_text: t.union([t.string, t.null]),
  action_url: t.union([t.string, t.null]),
  critical: t.boolean,
  enabled: t.boolean,
  header: t.union([t.string, t.null]),
  notification_type: t.keyof(NotificationType),
  seen: t.boolean,
  subheader: t.union([t.string, t.null]),
});

export type ManagerNotification = t.TypeOf<typeof tManagerNotification>;

export const tNotification = t.type({
  notifications: t.intersection([
    t.partial({
      alert: t.array(tManagerNotification),
    }),
    t.partial({
      upsell: t.array(tManagerNotification),
    }),
    t.partial({
      modal: t.array(tManagerNotification),
    }),
    t.partial({
      card: t.array(tManagerNotification),
    }),
  ]),
});
